<div class="d-flex flex-column justify-content-between h-100">
    <ngx-hm-header></ngx-hm-header>
    <div class="flex-grow-1">
        <a
            class="d-block text-center"
            href="/"
        >
            <img
                src="/assets/images/loghi/logo_hm.png"
                style="height: 100px!important;"
            >
        </a>

        <h6 class="my-2 form-text hm-title text-center">Il percorso nascita... nelle tue mani!</h6>
        <div class="clearfix links my-2">
            <a
                class="text-success"
                routerLink="/"
                routerLinkActive="active"
            >Torna alla home</a><br><br>
        </div>
        <div class="d-flex flex-column align-items-center">
            <div class="col-sm-12 col-md-6">
                <h5>Domande frequenti</h5>
                <hr>
            </div>
            <div class="col-sm-12 col-md-6 mb-4">
                <nb-select
                    fullWidth
                    [(ngModel)]="categoria_selected"
                    (ngModelChange)="cercaFaqPerCategoria()"
                >
                    <nb-option
                        class="justify-content-center"
                        *ngFor="let categoria of categorie"
                        [value]="categoria"
                    >{{categoria.nome}}</nb-option>
                </nb-select>
            </div>
            <div class="col-sm-12 col-md-6">
                <nb-accordion>
                    <nb-accordion-item
                        class="faq-accordion-item my-2"
                        *ngFor="let domanda of domande"
                    >
                        <nb-accordion-item-header>{{domanda.domanda}}
                        </nb-accordion-item-header>
                        <nb-accordion-item-body>
                            <div [innerHTML]="domanda.risposta"></div>
                        </nb-accordion-item-body>
                    </nb-accordion-item>
                </nb-accordion>
            </div>
        </div>
    </div>
    <div></div>
</div>
